import { useHomepagePageData } from '#src/app/pages/homepage/pageContext';

type Data = {
	marqueeItemCount: string;
	topImpactStoryCount: string;
	urls: {
		featuredPetitions: string;
		featuredTopics: string;
		featuredVictories: string;
		adminHome: string;
		userSearch: string;
		dmSearch: string;
	};
};

type Result = ModelHookResult<Data>;

const urls = {
	featuredPetitions: '/admin/featured_petitions',
	featuredTopics: '/admin/featured_topics',
	featuredVictories: '/admin/featured_victories',
	adminHome: '/admin',
	userSearch: '/admin/u',
	dmSearch: '/admin/decision-makers',
};

export function useHomepageStaffDrawer(): Result {
	const {
		data: { petitionMarqueeItems, topImpactStories },
	} = useHomepagePageData();

	return {
		data: {
			marqueeItemCount: String(petitionMarqueeItems.length),
			topImpactStoryCount: String(topImpactStories.length),
			urls,
		},
	};
}
